export function installZonePromisePolyfills(): void {
  installFinally();
  installAllSettled();
}

function installFinally(): void {
  const promisePrototype: any = Promise.prototype;
  if (promisePrototype.finally) {
    return;
  }
  promisePrototype.finally = function (onSettled: any) {
    if (typeof onSettled !== 'function') {
      return this.then(onSettled, onSettled);
    }
    const promiseConstructor: any = this.constructor || Promise;
    return this.then(
      (value: any) => promiseConstructor.resolve(onSettled()).then(() => value),
      (reason: any) => promiseConstructor.resolve(onSettled()).then(() => { throw reason; })
    );
  };
}

function installAllSettled(): void {
  const promiseConstructor: any = Promise;
  if (promiseConstructor.allSettled) {
    return;
  }
  promiseConstructor.allSettled = function (values: any) {
    const self: any = this;
    const settled = [];
    for (const value of values) {
      settled.push(self.resolve(value).then(
        (fulfilled: any) => ({ status: 'fulfilled', value: fulfilled }),
        (reason: any) => ({ status: 'rejected', reason: reason })
      ));
    }
    return self.all(settled);
  };
}



// WEBPACK FOOTER //
// ./src/zone-promise.polyfill.ts